
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cleartax.in/glossary/[...slug]",
      function () {
        return require("private-next-pages/cleartax.in/glossary/[...slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cleartax.in/glossary/[...slug]"])
      });
    }
  